export const dropdown2Options = ["dropdown2Option1", "dropdown2Option2", "dropdown2Option3", "dropdown2Option4"];
export const dropdown5Options = ["dropdown5Option1", "dropdown5Option2", "dropdown5Option3", "dropdown5Option4"];
export const dropdown5data = {
  dropdown5Option1: "dropdown5Osingular1",
  dropdown5Option2: "dropdown5Osingular2",
  dropdown5Option3: "dropdown5Osingular3",
  dropdown5Option4: "dropdown5Osingular4",
};
